module.exports = __webpack_public_path__ + "img/guiji.8f988ea9.png";